import { lazy } from "react";

export const SendInquirySuccessful = lazy(
  () => import("./SendInquirySuccessful")
);
export { default as InquiryCompany } from "./InquiryCompany";
export { default as InquiryItem } from "./InquiryItem";
export const QuickInquiry = lazy(() => import("./QuickInquiry"));
export { default as ContentGenerationChip } from "./ContentGenerationChip";
